type GenericObject = Record<string, unknown>;
type Primitive = string | number | boolean | null;
type CastData = {customDefault?: Primitive, nullable?: boolean, data?: GenericObject};
type TypeConfig = {type: string, default?: Primitive, data: GenericObject, nullable?: boolean};
export type PropsObject = Record<string, TypeConfig>;

const buildTypeConfig = (dataType: string, defaultValue: Primitive) => ({customDefault, nullable, data}: CastData = {}): TypeConfig => ({
    type: dataType,
    default: customDefault || defaultValue,
    data: data || {},
    nullable: nullable || false
});

const castValue = (value: Primitive, config: TypeConfig): Primitive | undefined => {
    if (config.nullable && value == null) {
        return value;
    }

    switch ( config.type ) {
        case 'boolean':
            return Boolean(value);
        case 'number':
            const newValue = Number(value);

            return  Number.isNaN(newValue) ? config.default : newValue;
        case 'string':
            return String(value);
        default:
            return value;
    }
};

export const typeConfigs = {
    string: buildTypeConfig('string', ''),
    number: buildTypeConfig('number', 0),
    boolean: buildTypeConfig('boolean', false),
    object: buildTypeConfig('object', null),
    any: buildTypeConfig('any', null)
};

const sanitizeData = (data: GenericObject, propsConfig: PropsObject) => {
    Object.entries(data).forEach(([key, value]) => {
        const config: TypeConfig = propsConfig[key] || typeConfigs.any();

        if (config.type === 'object') {

            if (value) {
                sanitizeData(data[key] as GenericObject, config.data as PropsObject);
            }
        } else {
            data[key] = castValue(value as Primitive, config);
        }
    });
};

export default sanitizeData;